import React from 'react'
import styled from 'styled-components'
import { useControls } from 'react-zoom-pan-pinch'
import { ArrowLeftIcon, CornersIcon, MinusIcon, PlusIcon } from '@radix-ui/react-icons'
import { Button, Flex, Box } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'


export const ConrolPanel: React.FC = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()
  const navigate = useNavigate()

  return (
    <Wrapper>
      <Flex gap="3" direction="column">
        <Box pb="6">
          <RoundButton onClick={() => navigate('/')} size="2" variant="soft">
            <ArrowLeftIcon/>
          </RoundButton>
        </Box>
        <RoundButton onClick={() => zoomIn()} size="2" variant="soft">
          <PlusIcon/>
        </RoundButton>
        <RoundButton onClick={() => resetTransform()} size="2" variant="soft">
          <CornersIcon/>
        </RoundButton>
        <RoundButton onClick={() => zoomOut()} size="2" variant="soft">
          <MinusIcon/>
        </RoundButton>
      </Flex>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  top: var(--space-4);
  left: var(--space-3);
`

const RoundButton = styled(Button)`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  cursor: pointer;
`